module.exports = __webpack_public_path__ + "static/media/logoSvenskdam.3b8ce566.png";